<template>
    <div class="mainview_div">
        <header class="common--header header--overide">
            <b-row>
                <b-col cols="10" v-if="store.isLogoAvailable">
                    <img :src="store.groupDetail.cssp" alt="" class="img-responsive-class" style='max-height: 70px;' />
                </b-col>
                <b-col cols="10" v-if="!store.isLogoAvailable">
                    <p class="app-header-title">{{ store.groupDetail.gnm }}</p>
                </b-col>
                <b-col cols="2" v-on:click="gomenu()" class="centering-block"><img src="images/home.png" alt="" /></b-col>
            </b-row>
        </header>
        <b-container class="user-info">
            <b-row>
                <b-col cols="10">{{ userName }}</b-col>
            </b-row>
        </b-container>
        <div class="side-menu-list">
            <ul>
                <li v-on:click="navigateTo('/symptom-chk')" hidden>
                    <img src="images/plus.png" alt="" />HEALTH SURVEY</li>
                <li v-if="!store.isAppointment" v-on:click="navigateTo('/schedule_checker')">
                    <img src="images/Schedule.svg" alt="" />SCHEDULE A TEST
                </li>
                <li v-on:click="navigateTo('/view_appointment')"><img src="images/View appointment.svg" alt="" />VIEW APPOINTMENT</li>
                <li v-on:click="navigateTo('/resources')"><img src="images/appoinment.png" alt="" />RESOURCES</li>
                <li v-on:click="navigateTo('/reset_password')"><img src="images/Edit profile.svg" alt="" />RESET PASSWORD</li>
                <li v-on:click="navigateTo('/test-results')"><img src="images/test result.svg" alt="" />TEST RESULT</li>
                <li v-on:click="navigateTo('/login')"><img src="images/Sign out.svg" alt="" />LOGOUT</li>
            </ul>
        </div>
        <b-modal ref="signout-modal" class="verticalCenterAlign" centered hide-header hide-footer>
            <label class="signoutText">Do you want to Logout?</label>
            <div></div>
            <br />
            <div class="signout-container rightAlign">
                <a href="javascript:void(0);" @click="signout" class="signoutButton"> CONFIRM</a>
                <a href="javascript:void(0);" @click="hideSignoutModal" class="signoutButton"> {{ this.cancel }}</a>
            </div>
        </b-modal>
        <b-modal ref="healthsurvey-modal" class="verticalCenterAlign" centered hide-header hide-footer>
            <label class="thankyouText"
                >The Health Survey is a feature that is available only from {{ this.store.mintodaytime12hrsFormate }} to
                {{ this.store.maxtodaytime12hrsFormate }} for use. Please contact your group administrator for more details.<br /><br
            /></label>
            <div style="text-align: center">
                <a href="javascript:void(0);" @click="hideModal" class="exitHyperLinkStyle"> {{ this.ok }}</a>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { store } from "@/store.js";
import apiCall from "@/services/api/apicall";

export default {
    name: "Home",
    components: {},
    data() {
        return {
            userName: "",
            store: store,
        };
    },
    methods: {
        navigateTo(routeName) {
            if (routeName == "/schedule_checker") {
                if (store.isAppointment == true) {
                    routeName = "/change_appointment";
                } else {
                    routeName = "/schedule_checker";
                }
            }
            if (routeName == "/login") {
                this.showSignOutModal();
                return;
            }
            if (routeName == "/symptom-chk") {
                // this.store.enableHealthSurvey = window.localStorage.getItem("enableHealthSurvey");
                if (!this.store.enableHealthSurvey) {
                    this.$refs["healthsurvey-modal"].show();
                    return;
                }
            }
            /*Stealth System Integration for web browsers - Starts*/
            if (routeName == "/test-results") {
                // console.log("this.store.userDetails:: ", this.store.userDetails);
                // console.log("authenticate this.store.userDetails.iid:: ", this.store.userDetails.iid);
                this.$router.push({ path: "/test-results" });
                // window.authenticateEnrolledUser(this.store.userDetails.iid, this.authCallback);
            } else {
                this.$router.push({ path: routeName });
            }
            /*Stealth System Integration for web browsers - Ends*/
        },

        /*Stealth System Integration for web browsers - Starts*/
        authCallback(response) {
            console.log("Data from authCallback", response);
            var self = this;
            if (response.responseCode == 200) {
                self.$swal({
                    icon: "success",
                    title: '<strong style="color:black;font-size=22px">Authentication Status</strong>',
                    html: '<p Style="color:green; font-size:20px">' + "Authentication Success.",
                    showCloseButton: true,
                }).then(function () {
                    // Redirect the user when success
                    self.$router.push({ path: "/test-results" });
                });
            } else {
                let errorMessage = "";
                if (response.responseCode == 400) {
                    errorMessage = "Authentication Failure";
                } else if (response.responseCode == 500) {
                    errorMessage = "Server Error";
                } else if (response.responseCode == 499) {
                    errorMessage = "User Cancels in Face Capture Screen";
                }
                this.$swal({
                    icon: "error",
                    title: '<strong style="color:black; font-size=22px">Authentication Status</strong>',
                    html: '<p Style="color:red; font-size:20px">' + errorMessage,
                    showCloseButton: true,
                });
            }
        },

        /*Stealth System Integration for web browsers - Ends*/
        gomenu() {
            this.$router.push({ path: "/app-home" });
        },
        showSignOutModal() {
            this.$refs["signout-modal"].show();
        },
        signout() {
            window.localStorage.removeItem("LI3EIB"); //Email
            window.localStorage.removeItem("QW3F4OV6"); //Password
            window.localStorage.removeItem("token");
            this.sendToken();
            this.$router.push({ path: "/login" });
        },
        hideSignoutModal() {
            this.$refs["signout-modal"].hide();
        },
        hideModal() {
            this.$refs["healthsurvey-modal"].hide();
        },
        sendToken() {
            let header = {
                headers: [
                    {
                        key: "Content-Type",
                        value: "application/json",
                        type: "text",
                    },
                ],
            };
            apiCall
                .apiServiceCall("Post", "", "/nfc", " ", header)
                .then((response) => {
                    if (response.data.status == 1) {
                        // console.log("Token Removed");
                        window.localStorage.setItem("mobileToken", "false");
                    }
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        // setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (error.response.status == 504) {
                        this.$router.push({ path: "/home" });
                    } else {
                        console.log(error.response.data.message);
                    }
                });
        },
    },
    mounted() {
        if (this.store.userDetails && this.store.userDetails.fnm) {
            this.userName = this.store.userDetails.fnm + " " + this.store.userDetails.lnm;
        } else {
            this.userName = "";
        }
    },
};
</script>
